import { Component, input, OnInit, signal } from "@angular/core";
import { Asset } from "app/classes/asset";
import { DerivedAsset } from "app/classes/derived-asset";
import { AssetService } from "app/shared/asset.service";

@Component({
  selector: "app-setpoint-query-derived",
  standalone: false,
  templateUrl: "./setpoint-query-derived.component.html",
  styleUrl: "./setpoint-query-derived.component.css",
})
export class SetpointQueryDerivedComponent implements OnInit {

  asset = input.required<Asset>();
  derivedAsset = signal<DerivedAsset>(null);

  constructor(private assetService: AssetService) {

  }

  ngOnInit(): void {
    this.assetService.getDerivedAsset(this.asset().id).then(a => this.derivedAsset.set(a));
  }

}
